<template>
  <a-modal
    class="transfer-admin"
    width="652px"
    title="转移企业管理员"
    :visible="$attrs.value"
    @cancel="handleCancel"
    @ok="hadleOk"
  >
    <sass-icon slot="closeIcon" type="hi-guanbidanchuangdanchuang" style="font-size: 16px;" />
    <a-form class="transfer-form passwords" :form="transferForm">
      <a-form-item label="手机号码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <p class="phone">{{ mobile }}</p>
      </a-form-item>
      <a-form-item label="短信验证码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <div class="captcha-input">
          <a-input
            v-decorator="[
              'verifyCode',
              { rules: [{ required: true, message: '请输入验证码' }, { pattern: /^\d{6}$/, message: '验证码格式错误' }], validateTrigger: 'blur' }
            ]"
            size="large"
            autocomplete="new-password"
            placeholder="请输入短信验证码"
          >
            <a-button slot="addonAfter" class="captcha-btn" ghost @click="handleCount">
              <count-down v-model="countStart" font-size="14px" counting-txt="$time秒后" end-txt="发送验证码" />
            </a-button>
          </a-input>
        </div>
      </a-form-item>
      <a-form-item label="登录密码" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <div class="input-area">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '请输入登录密码' },
                  { min: 6, message: '密码长度不能少于6个字符' },
                  { max: 20, message: '密码长度不能超过20个字符' }
                ],
                validateTrigger: 'blur'
              }
            ]"
            size="large"
            type="password"
            autocomplete="new-password"
            placeholder="请输入登录密码"
          />
          <!-- <span class="required-mark">*</span> -->
        </div>
      </a-form-item>
      <a-form-item label="选择用户" :colon="false" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <div class="select-area">
          <a-select
            v-decorator="[
              'userId',
              { rules: [{ required: true, message: '请选择一个用户' }], validateTrigger: 'change' }
            ]"
            showSearch
            class="user-select"
            :show-arrow="false"
            :defaultActiveFirstOption="false"
            :filterOption="false"
            placeholder="手机号码/用户名称"
            :notFoundContent="fetching ? undefined : null"
            @search="handleSearch"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="user in users" :key="user.id" :disabled="user.id === currentId" :value="user.id">
              <span>{{ user.mobile }} &emsp; </span>
              <span>{{ user.userName }}</span>
            </a-select-option>
          </a-select>
          <select-more
            class="in-select"
            :page-no="pageNo"
            :page-size="pageSize"
            :total="total"
            :total-page="totalPage"
            :users="users"
            :filterOption="true"
            @search="handleSearch"
            @set-value="handleSetValue"
            @page-change="handlePageChange"
            @size-change="handleSizeChange"
          />
          <!-- <span class="required-mark">*</span> -->
        </div>
        <p v-show="errMsg" class="err-msg">{{ errMsg }}</p>
      </a-form-item>
      <a-form-item>
        <a-row>
          <a-col :span="18" :offset="6" class="form-info">转移后，您账号将失去企业管理员身份</a-col>
        </a-row>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import CommonIcon from '@/components/common-icon'
import CountDown from '@/components/CountDown'
import SelectMore from './components/SelectMore'
import { sendVerifyCode, transferTenantAdmin, findTenantUsers } from '@/api/login'
import debounce from 'lodash/debounce'
import { Base64 } from 'js-base64'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TransferAdmin',
  components: {
    CommonIcon,
    CountDown,
    SelectMore
  },
  data() {
    this.handleSearch = debounce(this.handleSearch, 600)
    return {
      transferForm: this.$form.createForm(this),
      fetching: false,
      countStart: false,
      users: [],
      pageNo: 1,
      pageSize: 20,
      total: 0,
      totalPage: 0,
      errMsg: ''
    }
  },
  mounted() {
    this.queryUser()
  },
  computed: {
    ...mapGetters(['userInfo', 'mobile', 'areaCode']),
    currentId() {
      return this.userInfo.currentUser.id
    }
  },
  methods: {
    ...mapActions(['GetInfo', 'GetSystemList', 'ClearToken']),
    handleCount() {
      const { showErrMsg, countStart } = this
      if (countStart) return
      const data = {
        businessType: 'TRANSFER_TENANT_ADMIN',
        areaCode: this.areaCode,
        mobile: this.mobile
      }
      sendVerifyCode(data)
        .then(() => {
          this.$message.success('验证码发送成功，请注意查收！')
          this.countStart = true
        })
        .catch(err => {
          showErrMsg(err)
        })
    },
    handleCancel() {
      this.$emit('input', false)
    },
    // handleSearch: debounce(600, function(value) {
    //   this.queryUser(value)
    // }),
    handleSearch(value) {
      this.pageNo = 1
      this.pageSize = 20
      this.queryUser(value)
    },
    handlePageChange(page, value) {
      this.pageNo = page
      this.queryUser(value)
    },
    handleSizeChange(size, value) {
      this.pageNo = 1
      this.pageSize = size
      this.queryUser(value)
    },
    queryUser(value = null) {
      const { pageNo, pageSize } = this
      const that = this
      that.fetching = true
      that.users = []
      findTenantUsers({ mobileOrUserName: value, pageNo, pageSize })
        .then(res => {
          that.total = res.total
          that.totalPage = res.totalPage
          that.users = res.data
          that.fetching = false
        })
        .catch(err => {
          that.$notification.error({
            message: '错误',
            description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
            duration: 4
          })
        })
    },
    handleSetValue(value) {
      const { showErrMsg, transferForm } = this
      if (value === this.currentId) {
        showErrMsg({ msg: '当前用户不能切换自己' })
        return
      }
      transferForm.setFieldsValue({ userId: value })
    },
    hadleOk() {
      const {
        transferForm: { validateFields },
        showErrMsg,
        $message
        // $message,
        // GetInfo,
        // GetSystemList
      } = this
      // const that = this
      validateFields((err, values) => {
        if (!err) {
          const newvalues = { ...values, password: Base64.encode(values.password) }
          transferTenantAdmin(newvalues)
            .then(() => {
              $message.success('租户管理员切换成功！')
              this.ClearToken()
              setTimeout(() => {
                location.reload()
              }, 1000)
              // GetInfo().then(() => {
              //   GetSystemList().then(() => {
              //     that.$emit('input', false)
              //     that.$router.push({ name: 'CommonLogin' })
              //   })
              //   $message.success('租户管理员切换成功！')
              //   that.$emit('input', false)
              // })
            })
            .catch(err => showErrMsg(err))
        }
      })
    },
    showErrMsg(err) {
      if (err.code && err.msg) {
        const {
          transferForm: { getFieldsValue, setFields }
        } = this
        const { code, msg, invalidField } = err
        const values = getFieldsValue()
        if (invalidField) {
          setFields({
            [invalidField]: {
              value: values[invalidField],
              errors: [
                {
                  field: invalidField,
                  message: msg
                }
              ]
            }
          })
        } else {
          switch (code) {
            case 'AUTHEN0004':
              setFields({
                password: {
                  value: values.password,
                  errors: [
                    {
                      field: 'password',
                      message: msg
                    }
                  ]
                }
              })
              break
            case 'AUTHEN0013':
              setFields({
                verifyCode: {
                  value: values.verifyCode,
                  errors: [
                    {
                      field: 'verifyCode',
                      message: msg
                    }
                  ]
                }
              })
              break
            case 'AUTHEN0021':
              setFields({
                userId: {
                  value: values.userId,
                  errors: [
                    {
                      field: 'userId',
                      message: msg
                    }
                  ]
                }
              })
              break
            default:
              this.errMsg = msg
              break
          }
        }
      } else {
        this.$notification.error({
          message: '错误',
          description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
          duration: 4
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.transfer-form {
  margin: 0 auto;
  width: 360px;
}
.phone {
  height: 36px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 36px;
  letter-spacing: 0;
  color: rgba(51, 51, 51, .85);
}
.captcha-input,
.input-area,
.select-area {
  display: flex;
  & > input {
    flex: 1;
  }
  & > button {
    margin-left: 12px;
    width: 102px;
  }
}
.select-area {
  position: relative;
  .in-select {
    position: absolute;
    // top: 4px;
    right: 0;
  }
}
.user-select {
  height: 36px;
}
</style>
<style>
.user-select .ant-select-selection__rendered {
  height: 36px !important;
  font-size: 14px !important;
}
.user-select .ant-select-selection--single {
  height: 36px !important;
}
.user-select .ant-select-selection-selected-value {
  font-size: 14px;
  line-height: 36px;
}
</style>
